import { render, staticRenderFns } from "./Practical.vue?vue&type=template&id=aa0b97fa&scoped=true"
import script from "./Practical.vue?vue&type=script&lang=js"
export * from "./Practical.vue?vue&type=script&lang=js"
import style0 from "./Practical.vue?vue&type=style&index=0&id=aa0b97fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0b97fa",
  null
  
)

export default component.exports